// extracted by mini-css-extract-plugin
export var base = "_3n-0";
export var updateBanner = "_3n-1";